import React from 'react';

import './info-box.css'

const InfoBox = ({isTitleOnly=false, title="Title", text="Add Box Text", styleClass="", boxStyleClass=""})=> {

    const formattedText = !isTitleOnly?  text?.split('\n')?.map((line, index) => {
        return (
            <p key={index}>
                {line}
            </p>
        )
    }) : ""

    return (
        <div className={`info-box-wrapper ${boxStyleClass}`}>
            <div className="center underline">
                <h2>
                    {title}
                </h2>
            </div>
            {!isTitleOnly?
                <div className={`info-box-body center ${styleClass}`}>
                    {formattedText}
                </div> : ""
            }
        </div>
    )
}

export default InfoBox;